import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { fetchMovements, type MovementsPage } from '../api/movements.api';

const THIRTY_SECONDS = 1000 * 30;

/**
 * (Backfill automático — agregar descripción)
 *
 * @taskId T059a
 * @taskId T059b
 * @see functional/Specs/specs_cycle-2.md HU-07-FE
 */
export interface UseMovementsQueryParams {
  idCuenta: string | undefined;
  page: number;
  pageSize: number;
}

export function useMovementsQuery({
  idCuenta,
  page,
  pageSize,
}: UseMovementsQueryParams) {
  const skip = Math.max(0, (page - 1) * pageSize);
  return useQuery<MovementsPage, Error>({
    queryKey: ['movements', idCuenta, page, pageSize],
    queryFn: () =>
      fetchMovements({ idCuenta: idCuenta as string, skip, top: pageSize }),
    enabled: !!idCuenta,
    placeholderData: keepPreviousData,
    staleTime: THIRTY_SECONDS,
    refetchOnWindowFocus: false,
  });
}
